// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"99661906","116":"80b36732","221":"a847cc1a","242":"69734454","245":"59762cc7","441":"9a8089eb","453":"2f8b5c34","626":"fb4d0f27","836":"8e9aff59"}[chunkId] + ".chunk.js";
};